import axios from 'axios'

import history from '../history'
import auth from '../auth/service'

export let BASE_URL = '' // sembra che si possa fare, anche se brutto
if (process.env.REACT_APP_ENV === 'production') {
  BASE_URL = 'https://ranking.webranking.tools'
} else if (process.env.REACT_APP_ENV === 'staging') {
  BASE_URL = 'https://staging.ranking.webranking.tools'
} else {
  BASE_URL = 'http://localhost:9998'
}

const baseApiAddress = `${BASE_URL}/api/1/`

let _api = axios.create({
  baseURL: baseApiAddress,
})

_api.interceptors.request.use(
  (config) => {
    //if (process.env.NODE_ENV === 'production') {
    if (config.baseURL === baseApiAddress && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${auth.getAccessToken()}`
    }
    //}

    return config
  },
  (error) => Promise.reject(error)
)

const AUTH_ENDPOINT_HINTS = ['session/context/']
const LOGIN_PATH = '/login'
const NOT_AUTHORIZED_PATH = '/not-authorized'

const buildReferrer = (location = {}) => {
  const pathname = location?.pathname || '/'
  const search = location?.search || ''
  return `${pathname}${search}` || '/'
}

const isAuthBootstrapEndpoint = (config = {}) => {
  const baseURL = config.baseURL ?? ''
  const url = config.url ?? ''
  const normalized = `${baseURL}${url}`.toLowerCase()
  return AUTH_ENDPOINT_HINTS.some((hint) => normalized.includes(hint))
}

_api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response, config } = error
    if (!response || !config || isAuthBootstrapEndpoint(config)) {
      return Promise.reject(error)
    }

    if (response.status === 401) {
      auth.resetSession()
      history.replace({
        pathname: LOGIN_PATH,
        state: { referrer: buildReferrer(history.location) },
      })
    } else if (
      response.status === 403 &&
      response?.data?.code === 'service_access_denied'
    ) {
      history.replace(NOT_AUTHORIZED_PATH)
    }

    return Promise.reject(error)
  }
)

export const api = _api

export const GTM_ID = process.env.REACT_APP_GTM_ID

export const capitalize = (value) => {
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export const dateMonthYearFromString = (s) => {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]
  const splitted = s.split('-')
  return `${monthNames[Number(splitted[1]) - 1]} ${Number(splitted[0])}`
}

export const formatDateTime = data => {
  const d = new Date(data)
  const hours = d.getHours();
  let minutes = d.getMinutes();
  minutes = minutes < 10 ? '0'+minutes : minutes;
  const strTime = hours + ':' + minutes;
  return d.getDate()  + "-" + (d.getMonth()+1) + "-" + d.getFullYear() + "  " + strTime;
}

export const defaultFilters = [
  {
    "groupType": "and",
    "filters": [
      {
        "dimension": "page",
        "operator": "notContains",
        "expression": ".pdf"
      },
      {
        "dimension": "page",
        "operator": "notContains",
        "expression": ".doc"
      }
    ]
  }
]
